import styled from "styled-components";

export const MSearchListSection = styled.div`
  width: 100%;
  height: 100%;
`;
